import { createFileRoute, getRouteApi } from '@tanstack/react-router';

import { resolveIdentity } from '../modules/auth/domain/resolve-identity';
import { useAuthState } from '../modules/auth/ui/auth-state-context';
import { CheckinPage } from '../modules/checkin/ui/pages/CheckinPage';

export const Route = createFileRoute('/_authenticated/checkin')({
  component: CheckinPageWrapper,
});

// pwa-offline-first Slice 6 (design D12) — resolves the org/operator that
// captured a check-in, threaded into CheckinPage's outbox rows so a later
// sync can never upload an item under a DIFFERENT org's session. `getRouteApi`
// reads the parent `/_authenticated` route's context (its own `beforeLoad`
// resolves `offlineProfile`, task 3.6) without this file needing to import
// that route's `Route` object directly.
const authenticatedRouteApi = getRouteApi('/_authenticated');

function CheckinPageWrapper() {
  const locationId = localStorage.getItem('jq4race:active_location_id') ?? '';
  const { session } = useAuthState();
  const { offlineProfile } = authenticatedRouteApi.useRouteContext();

  // Shared with every other outbox-scoping call site (coordinator finding
  // #4) — see resolve-identity.ts's own doc comment.
  const identity = resolveIdentity(session, offlineProfile);

  return (
    <CheckinPage
      locationId={locationId}
      orgId={identity?.orgId ?? ''}
      capturedByUserId={identity?.capturedByUserId ?? ''}
    />
  );
}
